module.exports = __webpack_public_path__ + "assets/38dd5166184c770bc5b5fce5eb6f3545.png";